import Util from '../../util/Util';

const SingleZone = {
  recommendation(json) {
    if (!json || !json.recommendedItems || (json.recommendedItems.length <= 0)) {
      return false;
    }
    const { choiceId: encodedChoiceId, productId } = json.recommendedItems[0];

    const { choiceId, headerId, headerText } = Util.parseChoiceId(encodedChoiceId);
    if (!choiceId) {
      return false;
    }

    const recommendedIdsList = json.recommendedItems
      .map(({
        recommendedItemId: id, choiceId: itemChoiceId, clickTrackingURL, upcs, displayUpcImage, productType, colorName, images,
      }) => ({
        id,
        choiceId: itemChoiceId,
        clickTrackingUrl: Util.protocolLessUrl(clickTrackingURL),
        upcs,
        displayUpcImage,
        productType: productType || 'uncategorized',
        colorName: colorName || '',
        images: images || '',
      }));

    return {
      choiceId,
      headerId,
      headerText,
      productId,
      encodedChoiceId,
      recommendedIdsList,
      clickTrackingUrlPresent: (recommendedIdsList.length > 0 && recommendedIdsList[0].clickTrackingUrl && true),
      meta: (json.meta || ''),
      status: json.status,
      error: json.error,
      content: json.content,
    };
  },
};


export default SingleZone;
